import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getFollowUpEventList(token) {
  return axios.get(`${baseUrl}/follow_up-list`, {
    headers: {
      authorization: token,
    },
  });
}

// export function updateFollowUpEventById(token, id, data) {
//   return axios.patch(`${baseUrl}/event/${id}`, data, {
//     headers: {
//       authorization: token,
//     },
//   });
// }

// export function createFollowUpEvent(token, data) {
//   return axios.post(`${baseUrl}/event`, data, {
//     headers: {
//       authorization: token,
//     },
//   });
// }

// export function deleteFollowUpEventById(token, id) {
//   return axios.delete(`${baseUrl}/event/${id}`, {
//     headers: {
//       authorization: token,
//     },
//   });
// }
